import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React from 'react';
import { FormattedMessage } from 'react-intl-next';
import { deactivateUserOverviewMessages } from '../../messages';
import UserInfo from '../UserInfo';
import * as Styled from './styled';
import { DropdownList } from '../DropdownList';
import MessagesIntlProvider from '../MessagesIntlProvider';
export var DeactivateUserOverviewScreen = /*#__PURE__*/function (_React$Component) {
  _inherits(DeactivateUserOverviewScreen, _React$Component);
  var _super = _createSuper(DeactivateUserOverviewScreen);
  function DeactivateUserOverviewScreen() {
    var _this;
    _classCallCheck(this, DeactivateUserOverviewScreen);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "selectAdminOrSelfCopy", function (adminCopy, selfCopy) {
      return _this.props.isCurrentUser ? selfCopy : adminCopy;
    });
    _defineProperty(_assertThisInitialized(_this), "renderLoseAccessListElement", function () {
      var _this$props = _this.props,
        accessibleSites = _this$props.accessibleSites,
        user = _this$props.user;
      var hasAccessibleSites = accessibleSites && accessibleSites.length > 0;
      return /*#__PURE__*/React.createElement("li", null, !hasAccessibleSites && /*#__PURE__*/React.createElement(FormattedMessage, _extends({}, _this.selectAdminOrSelfCopy(deactivateUserOverviewMessages.paragraphLoseAccessAdminNoSites, deactivateUserOverviewMessages.paragraphLoseAccessSelfNoSites), {
        values: {
          fullName: user.fullName,
          b: function b(s) {
            return /*#__PURE__*/React.createElement("b", null, s);
          }
        }
      })), hasAccessibleSites && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(FormattedMessage, _extends({}, _this.selectAdminOrSelfCopy(deactivateUserOverviewMessages.paragraphLoseAccessAdmin, deactivateUserOverviewMessages.paragraphLoseAccessSelf), {
        values: {
          fullName: user.fullName,
          b: function b(s) {
            return /*#__PURE__*/React.createElement("b", null, s);
          }
        },
        tagName: 'p'
      })), /*#__PURE__*/React.createElement(Styled.AccessibleSitesWrapper, null, /*#__PURE__*/React.createElement(DropdownList, {
        accessibleSites: accessibleSites
      }))));
    });
    _defineProperty(_assertThisInitialized(_this), "renderPersonalDataListElement", function () {
      return /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(FormattedMessage, _this.selectAdminOrSelfCopy(deactivateUserOverviewMessages.paragraphPersonalDataAdmin, deactivateUserOverviewMessages.paragraphPersonalDataSelf)));
    });
    _defineProperty(_assertThisInitialized(_this), "renderBillingListElement", function () {
      return /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(FormattedMessage, _this.selectAdminOrSelfCopy(deactivateUserOverviewMessages.paragraphBillingAdmin, deactivateUserOverviewMessages.paragraphBillingSelf)));
    });
    return _this;
  }
  _createClass(DeactivateUserOverviewScreen, [{
    key: "render",
    value: function render() {
      var user = this.props.user;
      return /*#__PURE__*/React.createElement(MessagesIntlProvider, null, /*#__PURE__*/React.createElement(Styled.Screen, null, /*#__PURE__*/React.createElement(Styled.Title, null, /*#__PURE__*/React.createElement(FormattedMessage, this.selectAdminOrSelfCopy(deactivateUserOverviewMessages.headingAdmin, deactivateUserOverviewMessages.headingSelf))), /*#__PURE__*/React.createElement(FormattedMessage, _extends({}, this.selectAdminOrSelfCopy(deactivateUserOverviewMessages.firstLineAdmin, deactivateUserOverviewMessages.firstLineSelf), {
        tagName: "p"
      })), /*#__PURE__*/React.createElement(UserInfo, {
        user: user
      }), /*#__PURE__*/React.createElement(FormattedMessage, this.selectAdminOrSelfCopy(deactivateUserOverviewMessages.paragraphAboutToDeactivateAdmin, deactivateUserOverviewMessages.paragraphAboutToDeactivateSelf)), /*#__PURE__*/React.createElement(Styled.MainInformationList, null, this.renderLoseAccessListElement(), this.renderPersonalDataListElement(), this.renderBillingListElement()), /*#__PURE__*/React.createElement(FormattedMessage, _extends({}, this.selectAdminOrSelfCopy(deactivateUserOverviewMessages.lastLineAdmin, deactivateUserOverviewMessages.lastLineSelf), {
        tagName: "p"
      }))));
    }
  }]);
  return DeactivateUserOverviewScreen;
}(React.Component);
_defineProperty(DeactivateUserOverviewScreen, "defaultProps", {
  isCurrentUser: false
});
export default DeactivateUserOverviewScreen;